<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { VueContentLoading } from "vue-content-loading";
import { mapActions, mapGetters } from "vuex";
import AlertError from "@/components/alert_error";
import { required } from "vuelidate/lib/validators"; // for validators
import DatePicker from "vue2-datepicker"; // add DatePicker
import FileServices from "../../../services/files_export.js";
import { swal } from "../../../helpers/handle_error.js";

export default {
  page: {
    title: "تحميل البيانات",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, VueContentLoading, AlertError, DatePicker },
  data() {
    return {
      title: "تحميل البيانات",
      items: [
        {
          text: "الرئيسية",
          href: "/",
        },
        {
          text: "تحميل البيانات",
          active: true,
        },
      ],

      //Page errors.
      errors: [],

      //Permission vars.
      hasFormArtist: false,

      //form vars.
      forms: [],

      formExport: {
        formName: "",
        date: {
          from: "",
          to: "",
        },
        order: "",
      },

      //api uri.
      uri: {
        excel: "form-artist/export/excel/artists",
        zip_one: "form-artist/export/zip/one/artists",
        zip_two: "form-artist/export/zip/two/artists",
      },

      showAlert: false,
      loadingContent: true,
      submit: false,
      loadingButtonExportExcel: false,
      loadingButtonExportZipOne: false,
      loadingButtonExportZipTwo: false,
      downloadProgressValue: 0,
      showDownloadProgress: false,
    };
  },
  // vuelidate
  validations: {
    formExport: {
      formName: { required },
      date: {
        from: { required },
        to: { required },
      },
      order: { required },
    },
  },
  computed: {
    ...mapGetters("auth", ["getUser"]),
    getFileName() {
      return this.formExport.formName.text;
    },
    downloadProgress: {
      get() {
        return this.showDownloadProgress;
      },
      set(value) {
        this.showDownloadProgress = value == true;
        this.downloadProgressValue = 0;
      },
    },
  },
  methods: {
    ...mapActions("auth", ["hasAllPermission"]),
    handleError(error) {
      if (FileServices.axios.isCancel(error)) {
        // Request was canceled
        alert('Request canceled', error);
      }
      else
      {
        try {
          this.showAlert = true;
          if (error.response.status == 422)
            this.errors = Object.values(error.response.data.errors);
          else
            this.errors = [
              `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
            ];
        } catch (error) {
          swal.error("لا يمكن تحميل الملف");
        }
      }
    },
    download(_uri) {
      this.$v.$touch();
      if (this.$v.$error) return;

      // disabled button and show loading icon in clicked button. 
      switch (_uri) {
        case 'excel'    : this.loadingButtonExportExcel   = true; break;
        case 'zip_one'  : this.loadingButtonExportZipOne  = true; break;
        case 'zip_two'  : this.loadingButtonExportZipTwo  = true; break;
      }
      
      this.errors = [];
      let uri = this.uri[_uri];

      let params = {
        from: this.formExport.date.from,
        to: this.formExport.date.to,
        order: this.formExport.order,
      };

      FileServices.download(uri, { params: params })
        .then(() => {
          
          // this.downloadProgress = true;
          // show loading alert.
          swal.loadingFile(this.cancelDownload)

          params.download = 1; //to download file.
          FileServices.download(
            uri,
            { params: params, responseType: "blob" },
            this.onDownloadProgress
          )
            .then((response) => {
              FileServices.responseBlobDownload(response, this.getFileName+ (_uri == 'excel'?'':'.zip'))
              setTimeout(() => {
                // this.downloadProgress = false;
                //close loading alert.
                swal.close();
              }, 2000)
            })
            .catch(this.handleError)
        })
        .catch(this.handleError)
        .finally(() => {
          this.loadingButtonExportExcel = false;
          this.loadingButtonExportZipOne = false;
          this.loadingButtonExportZipTwo = false;
        });
    },
    onDownloadProgress(event) {
      this.downloadProgressValue = parseInt(
        Math.round((event.loaded / event.total) * 100)
      );
    },
    cancelDownload(){
      FileServices.cancelDownload();
      this.downloadProgress = false;
      swal.close();
    }
  },
  async created() {
    this.hasFormArtist = this.getUser.hasPermission("export_to_excel_artist");

    if (this.hasFormArtist)
      this.forms.push(
        { value: "form_artist", text: "استمارة المشاركات الفنية" },
      );

    this.loadingContent = false;

    this.formExport.formName = this.forms[0]    
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <AlertError :errors="errors" :showDismissibleAlert="showAlert" />

            <b-form v-if="!loadingContent" class="mb-3 mt-4 con-radius-input">
              <div class="row">
                <div v-if="downloadProgress" class="col-sm-12 pt-1">
                  <b-alert show variant="secondary" class="con-progress">
                    <b-progress height="20px" class="tag-progress">
                      <b-progress-bar
                        :value="downloadProgressValue"
                        :label="downloadProgressValue + '%'"
                      ></b-progress-bar>
                    </b-progress>
                    <b-button @click="cancelDownload()" variant="danger" class="btn-sm">
                      <i class="bx bx-x font-size-16 align-middle"></i>
                    </b-button>
                  </b-alert>
                </div>

                <b-form-group
                  class="col-md-6 mb-3"
                  label="الاستمارة :"
                  label-for="formExport.formName"
                >
                  <select
                    class="form-control select-p"
                    v-model="formExport.formName"
                    :class="{ 'is-invalid': $v.formExport.formName.$error }"
                    id="formExport.formName"
                  >
                    <!-- <option value="">حدد الاستمارة</option> -->
                    <option 
                      v-for="form in forms"
                      v-bind:value="{ value: form.value, text: form.text }"
                      v-bind:key="form.value"
                    >
                      {{ form.text }}
                    </option>
                  </select>
                  <div v-if="$v.formExport.formName.$error" class="invalid-feedback">
                    <span v-if="!$v.formExport.formName.required">
                      هذا الحقل الزامي
                    </span>
                  </div>
                </b-form-group>
                <b-form-group
                  class="col-md-6 mb-3"
                  label="ترتيب فرز البيانات :"
                  label-for="formExport.order"
                >
                  <select
                    class="form-control select-p"
                    v-model="formExport.order"
                    :class="{ 'is-invalid': $v.formExport.order.$error }"
                    id="formExport.formName"
                  >
                    <option value="">حدد نوع الفرز</option>
                    <option value="desc">فرز تنازلي</option>
                    <option value="asc">فرز تصاعدي</option>
                  </select>
                  <div v-if="$v.formExport.order.$error" class="invalid-feedback">
                    <span v-if="!$v.formExport.order.required"> هذا الحقل الزامي </span>
                  </div>
                </b-form-group>
                <b-form-group
                  class="col-md-6 mb-3"
                  label="من : "
                  label-for="formExport.date.from"
                >
                  <date-picker
                    id="formExport.date.from"
                    type="date"
                    lang="ar"
                    value-type="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    placeholder='ادخل الصيغة التالية   "يوم - شهر - سنة"'
                    v-model="formExport.date.from"
                    :class="{ 'is-invalid': $v.formExport.date.from.$error }"
                  ></date-picker>
                  <div v-if="$v.formExport.date.from.$error" class="invalid-feedback">
                    <span v-if="!$v.formExport.date.from.required">هذا الحقل الزامي</span>
                  </div>
                </b-form-group>
                <b-form-group
                  class="col-md-6 mb-3"
                  label="الى : "
                  label-for="formExport.date.to"
                >
                  <date-picker
                    id="formExport.date.to"
                    type="date"
                    lang="ar"
                    value-type="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    placeholder='ادخل الصيغة التالية   "يوم - شهر - سنة"'
                    v-model="formExport.date.to"
                    :class="{ 'is-invalid': $v.formExport.date.to.$error }"
                  ></date-picker>
                  <div v-if="$v.formExport.date.to.$error" class="invalid-feedback">
                    <span v-if="!$v.formExport.date.to.required">هذا الحقل الزامي</span>
                  </div>
                </b-form-group>
              </div>
              <div>
                <hr />
                <b-button
                  class="btn-block"
                  type="button"
                  @click="download('excel')"
                  variant="primary"
                  :disabled="
                    this.loadingButtonExportExcel ||
                    loadingButtonExportZipOne ||
                    loadingButtonExportZipTwo ||
                    downloadProgress
                  "
                >
                  <b-spinner v-if="this.loadingButtonExportExcel" small></b-spinner>
                  <span v-else>تحميل البيانات</span
                  >
                </b-button>
                <b-button
                  class="btn-block"
                  style="margin-right: 10px"
                  type="button"
                  @click="download('zip_one')"
                  variant="primary"
                  :disabled="
                    this.loadingButtonExportExcel ||
                    loadingButtonExportZipOne ||
                    loadingButtonExportZipTwo ||
                    downloadProgress
                  "
                >
                  <b-spinner v-if="this.loadingButtonExportZipOne" small></b-spinner>
                  <span v-else> تحميل الملفات حسب الاسم</span
                  >
                </b-button>
                <b-button
                  class="btn-block"
                  style="margin-right: 10px"
                  type="button"
                  @click="download('zip_two')"
                  variant="primary"
                  :disabled="
                    this.loadingButtonExportExcel ||
                    loadingButtonExportZipOne ||
                    loadingButtonExportZipTwo ||
                    downloadProgress
                  "
                >
                  <b-spinner v-if="this.loadingButtonExportZipTwo" small></b-spinner>
                  <span v-else> تحميل الملفات حسب القسم الرئيسي والمحور الفرعي</span
                  >
                </b-button>
              </div>
            </b-form>
            <!-- loading content -->
            <div v-else>
              <vue-content-loading :rtl="true" :width="400" :height="56">
                <rect x="0" y="4" rx="0" ry="0" width="2" height="7" />
                <rect x="4" y="6" rx="1" ry="1" width="30" height="3" />
                <rect x="35" y="7" rx="1" ry="1" width="364" height="1" />

                <rect x="0" y="17" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="21" rx="1" ry="1" width="400" height="10" />

                <rect x="0" y="39" rx="1" ry="1" width="400" height="1" />
                <rect x="0" y="43" rx="1" ry="1" width="20" height="10" />
              </vue-content-loading>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
